
import axios from 'axios'
import { cawsContract } from '../web3/index'
const PER_PAGE_DEFAULT = 25

export const getWalletTokens = async (walletAddress, options = {}) => {
  let { limit = PER_PAGE_DEFAULT, page = 1, includeMetaData = true } = options
  if (limit <= 0 || limit > PER_PAGE_DEFAULT) { limit = PER_PAGE_DEFAULT }

  const numberOfTokens = +await cawsContract.methods.balanceOf(walletAddress).call()

  if (numberOfTokens === 0) {
    const response = { items: [], metaData: { page, limit, hasMore: false, total: numberOfTokens, thisPage: 0 } }
    return response
  }

  // if (options?.fetchAll) {
  //   const walletAddressTokensPromises = []
  //   for (let index: number = 0; index < numberOfTokens; index++) {
  //     walletAddressTokensPromises.push(getTokenMetaDataByIndex({ walletAddress, index }, { includeMetaData }))
  //   }
  //   const walletAddressTokensPromisesResult: object[] = await Promise.all(walletAddressTokensPromises)
  //   return {
  //     items: walletAddressTokensPromisesResult,
  //     metaData: { page: 1, limit: numberOfTokens, hasMore: false, total: numberOfTokens, thisPage: walletAddressTokensPromisesResult.length }
  //   }
  // }

  const startIndex = (page - 1) * limit
  let endIndex = startIndex + limit
  let hasMore = true
  if (endIndex >= numberOfTokens) {
    endIndex = numberOfTokens
    hasMore = false
  }
  const walletAddressTokensPromises = []
  for (let index = startIndex; index < endIndex; index++) {
    walletAddressTokensPromises.push(getTokenMetaDataByIndex({ walletAddress, index }, { includeMetaData }))
  }
  const walletAddressTokensPromisesResult = await Promise.all(walletAddressTokensPromises)
  const response = { items: walletAddressTokensPromisesResult, metaData: { page, limit, hasMore, total: numberOfTokens, thisPage: walletAddressTokensPromisesResult.length } }
  return response
}


const getTokenMetaDataByIndex = async (getTokenMetaDataByIndexInput, options) => {
  const { walletAddress, index } = getTokenMetaDataByIndexInput
  const { includeMetaData } = options
  const tokenId = +await cawsContract.methods.tokenOfOwnerByIndex(walletAddress, index).call()
  if (!includeMetaData) { return tokenId }
  const tokenMetaDataURI = await cawsContract.methods.tokenURI(tokenId).call()
  const { data: tokenMetaData } = await axios.get(tokenMetaDataURI)
  return { ...tokenMetaData }
}
